import React from "react";
import { ReactComponent as CoinIcon } from "../../../asset/icons/coin.svg";
import { ReactComponent as Calender } from "../../../asset/icons/calender_gray_s.svg";
import ex_img from "../../../asset/image/ex_img_3.png";
import { ReactComponent as Logo } from "../../../asset/icons/amazon_logo_wob_lg.svg";
import moment from "moment-jalaali";

export default function ProductCard(props) {
    const {
        logo,
        startDate,
        endDate,
        name,
        description,
        requiredScore,
        discountCards,
        discountAmount,
        id,
        onClick,
    } = props;

    return (
        <div className="discount-card-main">
            <div className="exchange-card-container">
                <div
                    className="card-header"
                    style={{ backgroundImage: `url(${ex_img})` }}
                >
                    <div className="card-buttons">
                        <div>{discountAmount}%</div>
                        <div>
                            {/*<button className="sm-button"><Share/></button>*/}
                            {/*<button className="sm-button"><Bookmark/></button>*/}
                        </div>
                    </div>
                    <div className="logo-cv">
                        <div>
                            {logo ? <img src={logo} alt="logo" /> : <Logo />}
                        </div>
                        <div>
                            <CoinIcon />
                            <span> {requiredScore}</span>
                        </div>
                    </div>
                </div>
                <div className="card-content">
                    <h2>{name}</h2>
                    <p>{description}</p>
                    <div className="card-date">
                        <div>
                            <Calender />
                            <div>
                                {moment(startDate).format("jYYYY/jMM/jDD")}
                            </div>
                        </div>
                        <div>
                            <div>{moment(endDate).format("jYYYY/jMM/jDD")}</div>
                        </div>
                    </div>
                    <div className="discount-price">
                        تعداد کارت ها: {discountCards}
                    </div>
                </div>

                <button className="primary-button" onClick={() => onClick(id)}>
                    مشاهده
                </button>
            </div>
            {/* <button className="sm-button"></button> */}
        </div>
        // </div>
        //   <div className="discount-price">
        //     <div className="min-plus-st">
        //       <button><Plus/></button>
        //       <input readOnly/>
        //       <button><Mins/></button>
        //     </div>
        //   </div>
        //   //   <button className="primary-button">{t('UserPanel.Offers&Exchange.DiscountCard.IWantIt.Button')}</button>
        //   </div>
        // </div>
    );
}
